module.exports = __webpack_public_path__ + "static/media/idontneednoman.30a2f113.jpg";